import { ConfigProvider } from 'antd';
import { darkTheme, lightTheme } from 'configs/ThemeConfig';
import themes from 'devextreme/ui/themes';
import { refreshTheme } from 'devextreme/viz/themes';
import { resources } from 'lang';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useBodyClass from 'utils/hooks/useBodyClass';

export const AntdProvider = ({ children }) => {
	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig =
		currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme };

	useEffect(() => {
		currentTheme === 'light'
			? themes.current('generic.light')
			: themes.current('generic.dark');
		refreshTheme();
	}, [currentTheme]);
	return (
		<ConfigProvider
			theme={themeConfig}
			direction={direction}
			locale={currentAppLocale.antd}
		>
			{children}
		</ConfigProvider>
	);
};
